import React from 'react'

const Heading = ({heading , height,text,mt,mb}) => {
  return (
    <div class="pt-[150px] pb-[50px] flex items-center justify-center">

    <div className='max-w-md mx-auto  w-full'>
    <h2 className="flex flex-row flex-nowrap items-center my-8">
        <span className="flex-grow block border-t border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
        <span className={`flex-none block px-4 py-2.5  text-3xl font-semibold max-md:text-xl leading-none  uppercase text-[#07c991a8]`}>
           {heading}
        </span>
        <span className="flex-grow block border-t  border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
    </h2>
    </div>
    </div>
  )
}

export default Heading
